// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"416":"e7373332","496":"graphql-print"}[chunkId] || chunkId) + "." + {"416":"daa29bc77fcfd2cc","476":"7940c20f67c7cb23","496":"83edc8afc0370428","501":"fa2e874b731181fa","719":"cb74fb73ce7f2542","930":"d5798a2aa1fba830"}[chunkId] + ".js";
};